import keyMirror from 'keymirror';

export default keyMirror({
  CART_CREATE: null,
  CART_LOAD: null,
  CART_WAS_LOADED: null,
  ERROR_CART_LOAD: null,
  CART_ITEM_ADD: null,
  CART_ITEM_WAS_ADDED: null,
  ERROR_CART_ITEM_ADD: null,
  CART_ITEM_MODIFY: null,
  CART_ITEM_WAS_MODIFIED: null,
  ERROR_CART_ITEM_MODIFY: null,
  CART_ITEM_REMOVE: null,
  CART_ITEM_WAS_REMOVED: null,
  ERROR_CART_ITEM_REMOVE: null,
  NO_CART_WAS_LOADED: null,
  APPLY_COUPON: null,
  COUPON_WAS_APPLIED: null,
  COUPON_WAS_INVALID: null
});
